var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "staffs" },
    [
      _vm._t("header", [
        _c("h2", { staticClass: "mt-4" }, [
          _vm._v(
            "\n            " +
              _vm._s(_vm.$l10n.__("Attribution des licences")) +
              "\n        "
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "flex-row br staff-form-container fs-3 p-2 mt-5 mb-1 gray-0-bkg"
        },
        [
          _c("el-input", {
            ref: "search-input",
            attrs: {
              slot: "reference",
              "suffix-icon": "icon-search",
              onkeydown: "return (event.keyCode!=13);",
              placeholder: _vm.$t.__("pages.account.Staffs.search")
            },
            slot: "reference",
            model: {
              value: _vm.search,
              callback: function($$v) {
                _vm.search = $$v
              },
              expression: "search"
            }
          }),
          _vm._v(" "),
          _c("span", { staticClass: "semibold mr-3" }, [
            _vm._v(
              _vm._s(_vm.$l10n.__("%s collaborateurs au total", _vm.staffTotal))
            )
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          staticStyle: { width: "100%" },
          attrs: { data: _vm.filteredStaffList, "max-height": "617" }
        },
        [
          _c("el-table-column", {
            attrs: { label: _vm.$t.__("common.labels.name") },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "div",
                      { staticClass: "user-information" },
                      [
                        _c("avatar-randomized", {
                          attrs: {
                            firstname: scope.row.firstname,
                            lastname: scope.row.lastname,
                            "avatar-image": scope.row.avatar
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "ml-2 staff-name-container" },
                          [
                            _c("div", { staticClass: "semibold staff-name" }, [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    scope.row.firstname +
                                      " " +
                                      scope.row.lastname
                                  ) +
                                  "\n                        "
                              )
                            ]),
                            _vm._v(" "),
                            scope.row.job
                              ? _c("div", { staticClass: "fs-2 gray-60" }, [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(scope.row.job.name) +
                                      "\n                        "
                                  )
                                ])
                              : _vm._e()
                          ]
                        )
                      ],
                      1
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm.staffRole(scope.row)
                      ? _c("chip-label", {
                          attrs: {
                            color: _vm.staffRole(scope.row).backgroundColor,
                            label: _vm.staffRole(scope.row).label
                          }
                        })
                      : _vm._e()
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              width: 224,
              label: _vm.$t.__("common.labels.licence_type")
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "el-tooltip",
                      {
                        attrs: {
                          placement: "bottom-start",
                          disabled: !_vm.isReadOnly
                        }
                      },
                      [
                        _c(
                          "div",
                          { attrs: { slot: "content" }, slot: "content" },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(
                                  _vm.$l10n.__(
                                    "Pour modifier la licence de ce collaborateur"
                                  )
                                )
                            ),
                            _c("br"),
                            _vm._v(
                              "\n                        " +
                                _vm._s(
                                  _vm.$l10n.__(
                                    "merci de contacter un commercial"
                                  )
                                ) +
                                "\n                    "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-select",
                          {
                            staticClass: "w-2",
                            attrs: {
                              disabled: _vm.isReadOnly,
                              value: _vm.licenceDistributionForStaff(
                                scope.row.id
                              )
                            },
                            on: {
                              change: function($event) {
                                return _vm.handleLicenceChange(
                                  $event,
                                  scope.row
                                )
                              }
                            }
                          },
                          [
                            _c("el-option", {
                              attrs: {
                                value: null,
                                label: _vm.$t.__("common.labels.none")
                              }
                            }),
                            _vm._v(" "),
                            _vm._l(_vm.availablesProducts, function(license) {
                              return _c("el-option", {
                                key: license.code,
                                attrs: {
                                  label: license.title,
                                  value: license.code
                                }
                              })
                            })
                          ],
                          2
                        )
                      ],
                      1
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c(
            "infinite-loading",
            {
              attrs: {
                slot: "append",
                "force-use-infinite-wrapper": ".el-table__body-wrapper"
              },
              on: { infinite: _vm.infiniteHandler },
              slot: "append"
            },
            [
              _c(
                "div",
                {
                  staticClass: "py-2",
                  attrs: { slot: "spinner" },
                  slot: "spinner"
                },
                [_vm._v(_vm._s(_vm.$l10n.__("Chargement en cours...")))]
              ),
              _vm._v(" "),
              _c("div", { attrs: { slot: "no-more" }, slot: "no-more" }),
              _vm._v(" "),
              _c("div", { attrs: { slot: "no-results" }, slot: "no-results" })
            ]
          )
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }